import { ICompileService, IRootScopeService } from "angular";
import { IStatusData } from "./status-bar.component";

export interface IStatusBarRootScope extends IRootScopeService {
  showCloningStatus?: boolean;
  cloningMovingInProgress?: boolean;
}

export class StatusBarService {
  private isStatusBarInitialized = false;

  public static $inject = ["$rootScope", "$compile"];

  constructor(private $rootScope: IStatusBarRootScope, private $compile: ICompileService) {}

  show(): void {
    if (!this.isStatusBarInitialized) {
      const element = `<status-bar ng-if="$root.showCloningStatus"></status-bar>`;
      const scope = this.$rootScope.$new(true);
      const compiledElement = this.$compile(element)(scope);
      document.body.appendChild(compiledElement[0]);
      this.isStatusBarInitialized = true;
    }
    this.$rootScope.showCloningStatus = true;
    this.$rootScope.cloningMovingInProgress = true;
  }

  isVisible(): boolean {
    const statusBarIsVisible = document.getElementById("status-bar");
    return !!statusBarIsVisible;
  }

  hide(): void {
    this.$rootScope.showCloningStatus = false;
    this.$rootScope.cloningMovingInProgress = false;
  }

  updateStatus(statusData: IStatusData) {
    this.$rootScope.$broadcast("updateStatusBarData", statusData);
  }
}
